import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { RegisterService } from '../../../services';

class ConfirmationCodeSelect extends React.Component {
  constructor(props) {
    super(props);

    this.initialData = {
      hasData: false,
      currentSearch: null,
      currentController: null,
      codes: []
    }
    
    this.state = {
      ...this.initialData
    }
  }

  getNotFoundText() {
    if(this.state.currentSearch)
      return "Searching...";

    if(this.state.hasData)
      return "No codes found";

    return "Start typing to search"
  }

  searchCodes(code) {
    if(this.state.currentSearch != null){
      clearTimeout(this.state.currentSearch);
      this.state.currentController.abort();
    }

    if(!code) {
      this.setState({
        ...this.initialData
      });

      return;
    }

    if(code.length < 3)
      return;

    const newAbortController = new AbortController();

    const newTimeout = setTimeout(() => {
      RegisterService.searchConfirmationCodes(code, newAbortController.signal)
        .then(data => {
          this.setState({
            codes: data,
          });
        })
        .catch(() => {
          this.setState({
            codes: []
          });
        })
        .finally(() => {
          this.setState({
            currentSearch: null,
            currentController: null,
            hasData: true
          });
        })
    }, 500);

    this.setState({
      currentSearch: newTimeout,
      currentController: newAbortController
    });
  }

  render() {
    return (
      <Select
        showSearch
        allowClear
        placeholder="Confirmation Code"
        className={this.props.className}
        value={this.props.value}
        onSearch={(code) => this.searchCodes(code)}
        onClear={() => this.searchCodes("")}
        onChange={(val) => this.props.onChange(val ?? null)}
        filterOption={false}
        loading={this.state.currentSearch != null}
        notFoundContent={this.getNotFoundText()}
        options={this.state.codes.map(opt => ({ value: opt.ConsumerId, label: opt.ConsumerCode  }))}
      />
    );
  }
}

ConfirmationCodeSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  className: PropTypes.string,
};

ConfirmationCodeSelect.defaultProps = {
  value: null,
  className: ""
};

export { ConfirmationCodeSelect as default };
